import { adminHttpClient } from '../../commons/adminHttpClient'

export interface CompanyUserAssignedFamilyStatus {
  planPeriodId: string
  assignedFamilyStatuses: { companyUserId: string; familyStatusId: string }[]
}

const saveEmployeesFamilyStatuses = (data: CompanyUserAssignedFamilyStatus): Promise<any> => {
  return adminHttpClient.post('/Companies/AssignCompanyUserFamilyStatus', data)
}

export default saveEmployeesFamilyStatuses
